import { z } from 'zod';
import { shiftParticipantHoursHistoryStatus } from '../shared/entities/shiftParticipantHoursHistoryTypes';
export const getParticipantsWithPastShiftsTableFilterDataSchema = z.object({
    search: z.string().optional(),
    status: z.enum(shiftParticipantHoursHistoryStatus).array().optional(),
    occupations: z.string().array().optional(),
    dateRange: z
        .object({
        from: z.string().optional(),
        to: z.string().optional(),
    })
        .optional(),
    showPendingOnly: z.boolean().optional(),
});
export const participantWithPastShiftsRowSchema = z.object({
    participantId: z.string().uuid(),
    id: z.string().uuid(),
    status: z.enum(shiftParticipantHoursHistoryStatus),
    participantFullName: z.string().trim().min(1),
    occupations: z.string().array(),
    positionName: z.string().trim().min(1),
    shiftStartTime: z.number(),
    approvedHours: z.number(),
    pendingHours: z.number(),
    deniedHours: z.number(),
    shifts: z.number(),
});
